<template>
  <div>
    <div class="file-drop-zone" @click="triggerFileInput" @dragover.prevent @drop="handleFileDrop">
      <h2>Drop files here or click to upload</h2>
      <p>Securely share files up to 5GB</p>
      <input type="file" ref="fileInput" style="display: none;" @change="handleFileSelect" multiple>
    </div>
    <!-- Great Checkbox -->
    <div class="checkbox-upload">
      <label class="checkbox-container">
        <input v-model="privateFile" type="checkbox">
        <span class="checkmark"></span>
        Private file
      </label>
    </div>
    <div class="file-list" v-if="uploadedFiles.length > 0">
      <h3>Your Files</h3>
      <div v-for="file in uploadedFiles" :key="file.name" class="file-item">
        <div class="file-item-field">File: {{ file.name }}</div>
        <div class="file-item-field">Size: {{ file.size }}</div>
        <div class="file-item-field">UUID: {{ file.uuid }}</div>
        <div v-if="file.password" class="file-item-field">
          Password:
          <span v-if="file.showPassword">{{ file.password }}</span>
          <span v-else>••••••••</span>
          <button
              style="margin-left: 10px;font-size: 10px;padding: 4px;" class="btn"
              @click="togglePasswordVisibility(file)">
            {{ file.showPassword ? 'Hide' : 'Show' }}
          </button>
        </div>

        <div class="file-item-field">Uploaded At: {{ file.uploadedAt }}</div>
        <button  class="btn" @click="copyToClipboard(file)">Copy Info</button>
        <router-link class="btn" :style="{'margin-top':'5px'}" v-if="!file.password" target="_blank" :to="`/view/${file.uuid}`">Open to file</router-link>

      </div>
    </div>

    <div v-if="progress > 0" class="progress-bar">
      <div class="progress" :style="{ width: progress + '%' }"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import process from 'process';
// import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      uploadedFiles: [],
      progress: 0,
      privateFile: false
    };
  },
  methods: {
    async copyToClipboard(file) {
      let textToCopy = `File: ${file.name}\nUUID: ${file.uuid}\nUploaded At: ${file.uploadedAt}\n`;
      if (file.password) {
        textToCopy += `Link: https://vdrive.v64.dev/download/\nPassword: ${file.password}`;
      } else {
        textToCopy += `Link: https://vdrive.v64.dev/view/${file.uuid}`;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(textToCopy);
          alert('File information copied to clipboard!');
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
      } else {
        // Fallback method
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          alert('File information copied to clipboard!');
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        document.body.removeChild(textArea);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileDrop(e) {
      e.preventDefault();
      this.handleFiles(e.dataTransfer.files);
    },
    handleFileSelect(e) {
      this.handleFiles(e.target.files);
    },
    handleFiles(files) {
      for (let file of files) {
        this.uploadFile(file);
      }
    },
    togglePasswordVisibility(file) {
      file.showPassword = !file.showPassword;
    },
    // async calculateFileHash(file) {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.onload = (event) => {
    //       const wordArray = CryptoJS.lib.WordArray.create(event.target.result);
    //       const hash = CryptoJS.SHA256(wordArray).toString();
    //       resolve(hash);
    //     };
    //     reader.onerror = (error) => reject(error);
    //     reader.readAsArrayBuffer(file);
    //   });
    // },
    formatBytes(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1000;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    async uploadFile(file) {
      this.progress = 1; // Start progress from 1 to show some activity
      const chunkSize = 90 * 1024 * 1024; // 90 MB
      const totalChunks = Math.ceil(file.size / chunkSize);
      let uuid = null;
      let totalUploaded = 0;
      // const fileHash = file.hash || await this.calculateFileHash(file);
      // console.log('File hash:', fileHash);
      for (let i = 0; i < totalChunks; i++) { // Start from 0 for correct slicing
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append('fileChunk', chunk);
        formData.append('fileName', file.name);
        formData.append('privateFile', this.privateFile);
        formData.append('chunkIndex', i);
        formData.append('totalChunks', totalChunks);
        // formData.append('fileHash', fileHash);

        if (uuid) {
          formData.append('chunk-uuid', uuid); // Add uuid to formData if it's already obtained
        }

        try {
          const response = await axios.post(process?.env?.VUE_APP_API_URL + '/upload', formData, {
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                // Update total uploaded size
                totalUploaded = start + progressEvent.loaded;
                this.progress = Math.round((totalUploaded * 100) / file.size);
              }
            }
          });

          console.log({form: formData, response: response.data});

          if (!uuid) {
            uuid = response.data.uuid; // Save uuid from the first chunk's response
          }

          if (i === (totalChunks - 1)) { // Only push to uploadedFiles after the last chunk
            this.uploadedFiles.push({
              name: response.data.fileName,
              uuid: response.data.uuid,
              showPassword: false,
              password: response.data.password,
              uploadedAt: response.data['createdAt'],
              size: this.formatBytes(response.data['fileSize'] ?? 0)
            });
          }

        } catch (error) {
          console.error('Error uploading chunk:', error);
          this.progress = 0; // Reset progress on error
          return;
        }
      }
      this.progress = 0; // Reset progress after all chunks are uploaded
    }


  }
}
</script>

<style>

</style>